import { Typography } from 'antd';
import { ChevronIcon } from 'common/icons';
import { FC } from 'react';

import * as Styled from './profile-drawer-title.style';

interface ProfileDrawerTitleProps {
  title: string;
  onBack?: () => void;
  hideBackButton?: boolean;
}

const ProfileDrawerTitle: FC<ProfileDrawerTitleProps> = ({
  title,
  onBack,
  hideBackButton = false,
}) => {
  return (
    <Styled.Title>
      {!hideBackButton && (
        <Styled.ReturnButton
          onClick={onBack}
          icon={<ChevronIcon />}
          data-testid="profile-drawer-back-button"
        />
      )}
      <Typography.Title level={5}>{title}</Typography.Title>
    </Styled.Title>
  );
};

export { ProfileDrawerTitle };
